/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import AENavBackToMain from "../components/NavBackToMain";
import AENavBrand from "../components/NavBrand";
import AENavHelp from "../components/NavHelp";
import AENavLanguagePicker from "../components/NavLanguagePicker";
import AENavLogout from "../components/NavLogout";
import BSNav from "react-bootstrap/Nav";
import BSNavbar from "react-bootstrap/Navbar";
import BSNavItem from "react-bootstrap/NavItem";
import FAIcon from "react-fa";
import PropTypes from "prop-types";
import React, {Component} from "react";

export default class ManagementApplication extends Component {
  static propTypes = {
    assetsUrl: PropTypes.string.isRequired,
    children: PropTypes.any,
    languages: PropTypes.object.isRequired,
    organization: PropTypes.shape({
      friendlyId: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    sessionLanguage: PropTypes.string.isRequired,
    user: PropTypes.object,
  };

  static contextTypes = {
    __: PropTypes.func.isRequired,
  };

  render() {
    const {
      __,
    } = this.context;

    const {
      assetsUrl,
      languages,
      sessionLanguage,
      user,
    } = this.props;

    return (
      <div id="management">
        <BSNavbar fixedTop fluid>
          <BSNavbar.Header>
            <AENavBrand assetsUrl={assetsUrl}>
              {__("management::header")}
            </AENavBrand>
            <BSNavbar.Toggle />
          </BSNavbar.Header>
          <BSNavbar.Collapse>
            <BSNav pullRight>
              <BSNavItem>
                <FAIcon name="user" /> {user.name} ({user.email})
              </BSNavItem>
              <AENavLanguagePicker
                languages={languages}
                sessionLanguage={sessionLanguage}
              />
              <AENavLogout />
              <AENavHelp />
              <AENavBackToMain />
            </BSNav>
          </BSNavbar.Collapse>
        </BSNavbar>

        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../render/customApplications/management.jsx